import { FormControl, FormErrorMessage, FormLabel, Input } from "@chakra-ui/react";
import { forwardRef, useImperativeHandle, useState } from "react";
import RequiredMark from "./RequiredMark";

interface InputTextProps {
    label: string;
    extraText?: string;
    placeholderText: string;
    isRequired: boolean;
    rows?: number;
    cols?: number;
    maxLength: number;
    minLength?: number;
    initValue?: string;
}

const InputText = forwardRef((props: InputTextProps, ref) => {

    const [text, setText] = useState<string>(props.initValue ?? "");
    const [textError, setTextError] = useState<string>("");
    const validateText = () => {
        if (props.isRequired && !text) {
            setTextError(`${props.label} jest wymagane`);
            return false;
        } else if (text.length > props.maxLength) {
            setTextError(`${props.label} nie może być dłuższe niż ${props.maxLength} znaków`);
            return false;
        } else if (props.minLength != undefined && text.length < props.minLength) {
            setTextError(`${props.label} musi zawierać więcej niż ${props.minLength} znaków`);
            return false;
        } else {
            setTextError("");
            return true;
        }
    };

    useImperativeHandle(ref, () => ({
        validate: () => validateText(),
        value() { return text; }
    }));
  
    return (
        <FormControl isInvalid={!!textError}
            mt="5"
        >
            <FormLabel>{props.label} {props.isRequired && <RequiredMark />}</FormLabel>
            {props.extraText ? <>{props.extraText}</> : <></>}
            {props.rows || props.cols ?
                <textarea
                    rows={props.rows}
                    cols={props.cols}
                    maxLength={props.maxLength}
                    placeholder={props.placeholderText}
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    onBlur={validateText}>
                </textarea>
                :
                <Input
                    type="text"
                    placeholder={props.placeholderText}
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    onBlur={validateText}
                />
            }
            <FormErrorMessage>{textError}</FormErrorMessage>
        </FormControl>
    );
  });

  export default InputText;